import { TIERS } from '../v1/constants/'

export function getTier(numberOfCorrect) {
  const { TIER_ONE, TIER_TWO, TIER_THREE, TIER_FOUR, TIER_FIVE, TIER_SIX } = TIERS
  switch (numberOfCorrect) {
    case 1:
    case 2:
      return TIER_ONE
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      return TIER_TWO
    case 9:
    case 10:
    case 11:
    case 12:
      return TIER_THREE
    case 13:
    case 14:
    case 15:
      return TIER_FOUR
    case 16:
    case 17:
    case 18:
      return TIER_FIVE
    case 19:
    case 20:
      return TIER_SIX
    default:
      return TIER_ONE
  }
}



// WEBPACK FOOTER //
// ./src/lib/getTier.js